import * as React from "react";
import type { OptimizedImageProps } from "@site-factory/config";
import { cn } from "../utils";

export interface OptimizedImageComponentProps extends OptimizedImageProps {}

export function OptimizedImage({
  src,
  alt,
  width,
  height,
  aspectRatio,
  lazy = true,
  priority = false,
  placeholder = "none",
  blurDataURL,
  sizes,
  className,
}: OptimizedImageComponentProps) {
  const [loaded, setLoaded] = React.useState(false);

  const style: React.CSSProperties = {};
  if (aspectRatio && !height && !width) {
    style.aspectRatio = aspectRatio;
  }

  const showBlur = placeholder === "blur" && !loaded && blurDataURL;

  return (
    <div className={cn("relative overflow-hidden", className)} style={style}>
      {showBlur && (
        <div
          className="absolute inset-0 bg-cover bg-center blur-lg scale-105"
          style={{ backgroundImage: `url(${blurDataURL})` }}
          aria-hidden
        />
      )}
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        loading={priority ? "eager" : lazy ? "lazy" : "eager"}
        sizes={sizes}
        className={cn(
          "relative z-[1] h-full w-full object-cover transition-opacity duration-300",
          loaded ? "opacity-100" : "opacity-0"
        )}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
}
